"use strict";

$(".video-post-item").each((index, element) => {
    $(element).find('video').on("ended", function () {
        $(element).find('.play-button').fadeIn();
    });
    $(element).find('.post-video').on('click', (event) => {
        const video = $(event.currentTarget).find('video')[0]; // get the video element
        if (video.playing) {
            video.pause();
            $(event.currentTarget).closest('.post-video').find('.play-button').fadeIn();
        }
         else {
            video.play();
            $(event.currentTarget).closest('.post-video').find('.play-button').fadeOut();
        }
    });
});